module.exports = __webpack_public_path__ + "static/media/IconoPila-full.3618da48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-inalambrico/IconoPila-full.svg
// module id = 203
// module chunks = 0